import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 12.5h9M12.5 8v9m8.799-3 2.201-1.5-2.201-1.54A8.935 8.935 0 0 0 14 3.677L12.5 1.5 11 3.678a8.935 8.935 0 0 0-7.298 7.281L1.5 12.5 3.702 14A8.935 8.935 0 0 0 11 21.282l1.5 2.218 1.5-2.218A8.935 8.935 0 0 0 21.3 14Z",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }